<h2 class="font-bold text-text text-2xl pb-4">Signature</h2>
<app-section-lock-alert [section]="Section.DOCUMENTS" />
<form [formGroup]="signatureForm" [appSectionLock]="Section.DOCUMENTS">
  @if (isLoading()) {
    <div class="relative w-full h-[455px]">
      <app-skeleton />
    </div>
  } @else {
    <app-tabs (tabChange)="tabChangeValue($event)">
      <app-tab [title]="tabTitles[0]">
        <app-signature-typed-text
          [(areSignatureTabsPristine)]="areSignatureTabsPristine"
          [isDisabled]="Section.DOCUMENTS | sectionLocked" />
      </app-tab>
      <app-tab [title]="tabTitles[1]">
        <app-signature-container
          [(areSignatureTabsPristine)]="areSignatureTabsPristine"
          [isDisabled]="Section.DOCUMENTS | sectionLocked" />
      </app-tab>
      <app-tab [title]="tabTitles[2]">
        <app-input-file
          [acceptedFileTypes]="acceptedSignatureTypes"
          placeholder="Upload you signature in format JPG, JPEG, PNG or PDF"
          label="Signature"
          formControlName="signature_file" />
      </app-tab>
    </app-tabs>
    <div class="mt-8">
      <app-checkbox
        label="By checking this box I agree that my electronic signature represented above is the legal equivalent of my manual signature."
        id="terms"
        [disabled]="Section.DOCUMENTS | sectionLocked"
        formControlName="terms" />
    </div>
  }
</form>
